import { Component, Output, EventEmitter, Input } from '@angular/core';

import { HisNavigationService, HisNotificationService, HisUiService, HisAuthService, HisGlobalDataService } from 'hisng';

import { Publication } from 'app/fs/res/publication/model/publication';
import { DATA_SERVICE_KEY_CHILD_PUBLICATION,
    DATA_SERVICE_KEY_PUBLICATION,DATA_SERVICE_KEY_REASEARCH_ACTIVITY } from 'app/fs/res/publication/model/constants';
import { Conference } from 'app/fs/res/publication/model/conference';
import { ConferenceService } from 'app/fs/res/publication/service/conference.service';
import { ResearchActivity } from '../../../research-activity/model/research-activity';
import { ConferenceModuleOptions } from 'app/fs/res/publication/component/conference/conference-module.options';

@Component( {
    selector: 'res-conference-plam',
    templateUrl: './conference-plam.component.html',
} )
export class ConferencePlamComponent {
    public readonly moduleOptions = ConferenceModuleOptions;

    @Input() selectedConference: Conference;
    @Input() publication: Publication;
    @Input() researchActivity: ResearchActivity;
    @Input() childPublication: Publication;
    @Input() dDKey = '';
    @Output() selectedConferenceChange = new EventEmitter<Conference>();
    @Output() navigationLastUrlChange = new EventEmitter<string>();

    filteredConferences: Conference[];

    constructor(
        public auth: HisAuthService,
        private conferenceService: ConferenceService,
        private navigationService: HisNavigationService,
        private notificationService: HisNotificationService,
        public hisUiService: HisUiService,
        private globalDataService: HisGlobalDataService ) {
    }

    filterConference( event: { query: string } ) {
        let query = event.query;
        this.conferenceService.getConferences( query ).subscribe( (c: Conference[]) => {
            this.filteredConferences = c;
        } );
    }

    onClear(): void {
        this.selectedConference = null;
        this.selectedConferenceChange.emit( null );
    }

    onSelectByAutocomplete() {
        if ( !this.selectedConference ) {
            this.notificationService.errorI18nRes( 'fs.res.publication.conference.error' );
        } else {
            this.selectedConferenceChange.emit( this.selectedConference );
        }
    }

    onSelectBySearchPopup( $event: any[] ) {
        let conferenceId: number = parseInt( $event[0].id, 10 );
        this.conferenceService.getConferenceById( conferenceId ).subscribe( (c: Conference) => {
            this.selectedConference = c;
            this.selectedConferenceChange.emit( this.selectedConference );
        } );
    }

    getConferences(): Conference[] {
        return this.selectedConference ? [this.selectedConference] : [];
    }

    onBeforeNavigate() {
        this.navigationLastUrlChange.emit( window.location.href );

        if(this.researchActivity){
            this.globalDataService.setData( DATA_SERVICE_KEY_REASEARCH_ACTIVITY, this.researchActivity );
            this.navigationService.stopDirtyTracking();
        } else {
            this.globalDataService.setData( DATA_SERVICE_KEY_PUBLICATION, this.publication );
            if (this.childPublication) {
                this.globalDataService.setData(DATA_SERVICE_KEY_CHILD_PUBLICATION, this.childPublication);
            }
            this.navigationService.stopDirtyTracking();
        }
    }
}
